// Helpers to add a schedule event to Google Calendar or download an .ics file.
const pad = (n) => String(n).padStart(2, "0");
const parseISO = (s) => { const [y, m, d] = s.split("-").map(Number); return { y, m: m - 1, d }; };

function times(e) {
  const { y, m, d } = parseISO(e.date);
  let sh = 10, sm = 0;
  const tm = (e.time || "").match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
  if (tm) { sh = (+tm[1] % 12) + (/pm/i.test(tm[3]) ? 12 : 0); sm = +tm[2]; }
  const allDay = e.type === "open_studio" || /day/i.test(e.duration || "");
  const start = new Date(y, m, d, sh, sm);
  let hrs = 2;
  const dm = (e.duration || "").match(/(\d+(?:\.\d+)?)\s*hour/i);
  if (dm) hrs = parseFloat(dm[1]);
  const end = new Date(start.getTime() + hrs * 3600000);
  return { start, end, allDay, y, m, d };
}

const fmtLocal = (dt) => `${dt.getFullYear()}${pad(dt.getMonth() + 1)}${pad(dt.getDate())}T${pad(dt.getHours())}${pad(dt.getMinutes())}00`;
const fmtDate = (y, m, d) => `${y}${pad(m + 1)}${pad(d)}`;

function details(e) {
  const url = typeof window !== "undefined" ? window.location.origin + (e.link || "") : (e.link || "");
  return `${e.description || ""}${url ? `\n\nBook: ${url}` : ""}`;
}
const loc = (e) => e.location || "The Cake Society Studio";

export function googleCalUrl(e) {
  const t = times(e);
  let dates;
  if (t.allDay) {
    const next = new Date(t.y, t.m, t.d + 1);
    dates = `${fmtDate(t.y, t.m, t.d)}/${fmtDate(next.getFullYear(), next.getMonth(), next.getDate())}`;
  } else {
    dates = `${fmtLocal(t.start)}/${fmtLocal(t.end)}`;
  }
  const p = new URLSearchParams({ action: "TEMPLATE", text: `Cake Society — ${e.title}`, dates, details: details(e), location: loc(e) });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

function icsString(e) {
  const t = times(e);
  const esc = (s) => (s || "").replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;");
  let dts, dte;
  if (t.allDay) {
    const next = new Date(t.y, t.m, t.d + 1);
    dts = `DTSTART;VALUE=DATE:${fmtDate(t.y, t.m, t.d)}`;
    dte = `DTEND;VALUE=DATE:${fmtDate(next.getFullYear(), next.getMonth(), next.getDate())}`;
  } else {
    dts = `DTSTART:${fmtLocal(t.start)}`;
    dte = `DTEND:${fmtLocal(t.end)}`;
  }
  return [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Cake Society//Schedule//EN", "BEGIN:VEVENT",
    `UID:${e.id || Math.random().toString(36).slice(2)}@cakesocietystudio.com`,
    `DTSTAMP:${fmtLocal(new Date())}`, dts, dte,
    `SUMMARY:${esc("Cake Society — " + e.title)}`,
    `DESCRIPTION:${esc(details(e))}`,
    `LOCATION:${esc(loc(e))}`, "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
}

export function downloadICS(e) {
  const blob = new Blob([icsString(e)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(e.title || "event").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.ics`;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
